// extracted by mini-css-extract-plugin
module.exports = {"areaColumn":"styles_areaColumn__199ml","onlyColumn":"styles_onlyColumn__XgfSy","link":"styles_link__Z9NNo"};